const flows = {
    Unified: "/unified",
    Error: "/error",
    InstantOffer: "/",
};

export default flows;
